import { trackStructEvent } from "@catchoftheday/analytics";
export var trackOpenWidget = function trackOpenWidget() {
  trackStructEvent({
    category: "postcode widget",
    action: "open postcode switcher"
  });
};
export var trackInitialLocation = function trackInitialLocation(location) {
  trackStructEvent({
    category: "postcode widget",
    action: "switch postcode",
    label: "current location",
    property: location.toLowerCase()
  });
};
export var trackSetLocation = function trackSetLocation(location) {
  trackStructEvent({
    category: "postcode widget",
    action: "switch postcode",
    label: "entered postcode",
    property: location.toLowerCase()
  });
};